export const THREAD_ID = 'disqus_thread';
export const EMBED_SCRIPT_ID = 'dsq-embed-scr';

export const COMMENT_COUNT_CLASS = 'disqus-comment-count';
export const COMMENT_COUNT_SCRIPT_ID = 'dsq-count-scr';

export const COMMENT_EMBED_WIDTH = 420;
export const COMMENT_EMBED_HEIGHT = 320;

export const RECOMMENDATIONS_ID = 'disqus_recommendations';
export const RECOMMENDATIONS_SCRIPT_ID = 'dsq-recs-scr';

export const CALLBACKS = [
    'preData',
    'preInit',
    'onInit',
    'onReady',
    'afterRender',
    'preReset',
    'onIdentify',
    'beforeComment',
    'onNewComment',
    'onPaginate',
];
